export default __webpack_public_path__ + "static/media/OOE.585a35bf.svg";